<template>
  <div>
      <div @click="share()"  class="vCenter btndiv">
          <img src="/img/icon/share.png" alt="">
          <div class="btntext">
            分享
          </div>
      </div>
      <div v-show="mask" id="mask1">
          <div id="login">
              <img src="/img/close1.png" alt class="indexCloseBtn" @click="mask=false" />
              <div class="qrcodebox" align="center">
                  <div class="codetitle">请扫描下面的二维码</div>
                  <!-- <canvas id="canvas" class="qrcode"></canvas> -->
                  <div id="sharecanvas2" ref="sharecanvas2"></div>
              </div>
          </div>
      </div>
      <div class="shareImg" @click="showShareImg=false" v-show="showShareImg">
          <img src="/img/icon/shareimg.png" alt="">
      </div>
  </div>    
</template>
<script>
// import QRCode from 'qrcode'
export default {
  name: "UmShare",
  data() {
    return {
      umid: '',
      showShareImg: false,
      mask: false,
      sharetitle: "联信应用",
      imgurl: "https://dapp.umnet.cn/img/um.png"
    };
  },
  props: ["title","url","sharetitle","imgurl"],
  mounted() {
    var that = this;
    that.umid=$UMCore.uncompile("umid")
    var that = this
    window.goBack = that.goBack
    console.log(JSON.stringify({
            functionname: "wxshare",
            umid: $UMCore.uncompile("umid")
        }))
    var ua = window.navigator.userAgent.toLowerCase(),status;
    // console.log("ua = " + ua.indexOf('micromessenger'));
    if(ua.indexOf('micromessenger') != -1) {
      $UMCore.post("route.lua", {
          data: JSON.stringify({
              functionname: "wxshare",
              // umid: $UMCore.uncompile("umid")
              htmlpage: location.pathname
          })
      })
      .then((res)=>{
          if (res.data.status == 1) {
              let noSharp = location.href.split('#')[0];
              let url = noSharp.includes('?') ? `${noSharp}&umid=${$UMCore.uncompile("umid")}` : `${noSharp}?umid=${$UMCore.uncompile("umid")}`
              console.log("@@@@@@ - " + url)
              wx.config({
                  debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                  appId: res.data.appid, // 必填，公众号的唯一标识
                  timestamp: res.data.timestamp, // 必填，生成签名的时间戳
                  nonceStr: res.data.noncestr, // 必填，生成签名的随机串
                  signature: res.data.signature, // 必填，签名
                  jsApiList: ["updateAppMessageShareData"]
              });
              wx.ready(function() {
                  wx.updateAppMessageShareData({
                      title: that.sharetitle, // 分享标题
                      desc: that.title, // 分享描述
                      link: that.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                      imgUrl: that.imgurl, // 分享图标
                      success: function() {
                          // 用户点击了分享后执行的回调函数
                      }
                  });
              });
          }
      })
      .catch((err)=>{
          console.log(err)
      })
    }
  },
  methods: {
    share() {
        var that = this
        let isUmapp = navigator.userAgent.indexOf("umapp") > -1
        if (isUmapp) {
            var u = navigator.userAgent, app = navigator.appVersion;
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端
            var map = {}
            map.type = "cardShare"
            map.title = "联信应用"
            map.desc = that.title
            map.url = that.url
            map.sharelogo = "https://dapp.umnet.cn/img/um.png"
            if (isIOS) {
                window.webkit.messageHandlers.event.postMessage(map)
            } else if(isAndroid) {
                var newMap = JSON.stringify(map)
                android.event(newMap)
            }
        } else {
            var ua = window.navigator.userAgent.toLowerCase(),status;
            // console.log("ua = " + ua.indexOf('micromessenger'));
            if(ua.indexOf('micromessenger') == -1) {
                that.mask = true
                that.sharecode = true;
                $("#sharecanvas2").html("");
                this.$nextTick(() => {
                  let qrcode1 = new QRCode("sharecanvas2", {
                    width: 200,
                    height: 200,
                    text: that.url, // 二维码地址
                    colorDark: "#000",
                    colorLight: "#fff"
                  });
                });
            } else {
                that.showShareImg = true
            }
        }
    },
    
  },
  components: {
    // QRCode: QRCode
	},
};
</script>
<style lang="scss" scoped>
.btndiv {
  cursor: pointer;
  margin-left: 16px;
  img {
    width: 16px;
    height: 16px;
  }
  .btntext {
    margin-left: 4px;
    font-size: 12px;
    color: #999;
  }
}
.shareImg{
    position: fixed;
    z-index: 200;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #000000, $alpha: 0.7);
    img{
        width: 230px;
        float: right;
        margin-right: 20px;
    }
}
#mask1 {
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.2);
    z-index: 99;
}
#login {
    position: absolute;
    width: 290px;
    height: 330px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
}
.indexCloseBtn {
    position: absolute;
    width: 25px;
    height: 25px;
    display: inline-block;
    right: -10px;
    top: -10px;
    z-index: 2;
    cursor: pointer;
}
#login .loginBox {
    margin: auto !important;
}
.qrcodebox {
    position: relative;
    background: #fff;
    width: 290px;
    border-radius: 6px;
    line-height: normal;
    padding: 0 30px;
    height: 330px;
}
.codetitle {
    padding: 40px 0 20px;
    font-size: 16px;
}
</style>




// WEBPACK FOOTER //
// src/packages/share/um-share.vue